module.exports = __webpack_public_path__ + "static/img/bg-sm.2a1eaa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-banner/doublelift-course/bg-sm.png
// module id = pGD0
// module chunks = 35